module.exports = __webpack_public_path__ + "img/centrum-placemat.41fecb71.jpg";